import { DebugEvent } from 'core/DebugEvent';

interface DebugMouseWheelEventInterface {
	delta: number;
	realDelta?: Number;
	isHuman?: boolean;
}

export class DebugMouseWheelEvent extends DebugEvent implements DebugMouseWheelEventInterface {
	public static eventName: string = 'MOUSE_WHEEL_EVENT';
	public delta: number;
	public realDelta: number;
	public isHuman: boolean;

	constructor(parameters: DebugMouseWheelEventInterface) {
		super(parameters);
	}
}
